export enum PositionsType {
  PRINT = 'print-positions',
  DIGITAL = 'digital-positions',
  RADIO = 'radio-positions',
  TV = 'tv-positions',
  CAMPAIGNS = 'campaigns',
  POS = 'point-of-sale-positions',
}
